import { Models } from 'appwrite';
import { Membership } from '@domain/account/models/Membership';

export class MembershipMapper {
    static toModel(document: Models.Membership): Membership {
        return {
            $id: document.$id,
            $createdAt: document.$createdAt,
            $updatedAt: document.$updatedAt,
            userId: document.userId,
            userName: document.userName,
            userEmail: document.userEmail,
            teamId: document.teamId,
            teamName: document.teamName,
            invited: document.invited,
            joined: document.joined,
            confirm: document.confirm,
            mfa: document.mfa,
            roles: document.roles
        };
    }
}
